export default "__VITE_ASSET__gvz0tS0F__"